
export type SortMode = [string, 'asc' | 'desc'];
export type SortFlags = [string, 'asc' | 'desc'];

export const applySort = <T>(objects: readonly T[], sort: SortMode, ...flags: SortFlags[]) => {
    if (!sort || sort.length < 2) return objects;
    const [prop, order] = sort;
    return objects.slice().sort((a, b) => {
        for (const [fk, fo] of flags) {
            const v = fo === 'desc' ? -1 : 1;
            if (a[fk] === b[fk]) continue;
            if (!a[fk]) return 1 * v;
            if (!b[fk]) return -1 * v;
        }
        {
            const v = order === 'desc' ? -1 : 1;
            if (a[prop] > b[prop]) return 1 * v;
            if (a[prop] < b[prop]) return -1 * v;
        }
        return 0;
    });
};

const normalize = (x: string) => (x || '').toLowerCase().replace(/\s/g, '');
const match = (str: string, val: string) => normalize(str).includes(val);

export const applyFilter = <T>(objects: readonly T[], filter: string) => {
    filter = normalize(filter);
    if (!filter) return objects;
    const keys = ['label', 'name', 'id'];
    return objects.filter((x: any) => {
        for (const k of keys) {
            if (k in x && match(x[k], filter)) return true;
        }
        return false;
    });
};
